module.exports = __webpack_public_path__ + "static/media/redCheckbox.d1e5bcdc.svg";